import React from "react"
import ReactGA from "react-ga"

if (process.browser) {
  ReactGA.initialize("UA-130161486-2")
  ReactGA.pageview(window.location.pathname + window.location.search)
}

export default ({ children }) => <div>{children}</div>
